import store from '../store';
import { AxiosResponse } from 'axios';
import { ApiMessage, BaseResponse } from '../apis';
import i18n from '../locale';
import { Dictionary, isEmpty } from 'lodash';
import config from '../config';
import { hasPermission } from './guard';

const UtilPlugin = {
  install(Vue, options: any = {}) {
    Vue.prototype.$util = this;
  },
  hasPermission(val?: { context: string, action: string }) {
    return hasPermission(val);
  },
  getConfig() {
    return config;
  },
  isClient() {
    return store.getters.user && store.getters.user.organization === "CLIENT";
  },
  preventNegativeNumber(event: KeyboardEvent) {
    const { key } = event;
    if (key === '-') {
      event.preventDefault();
    }
  },

  open({ message, title = null, inputs = null, buttons = [], html = false }) {
    return new Promise((resolve, reject) => {
      store.dispatch('vueDialogOpen', {
        message,
        title,
        inputs,
        buttons,
        html,
        resolveCallback: resolve,
        rejectCallback: reject
      });
    });
  },

  close({ id }) {
    return store.dispatch('vueDialogClose', { id });
  },

  showLoading() {
    return store.commit('LOADING_SHOW');
  },
  hideLoading() {
    return store.commit('LOADING_HIDE');
  },

  showRouting() {
    return store.commit('ROUTING_SHOW');
  },
  hideRouting() {
    return store.commit('ROUTING_HIDE');
  },

  error(message, title = null, options: any = {}) {
    return this.open({ message });
  },

  goToErrorField(observer: any) {
    for (const key of Object.keys(observer.errors)) {
      if (observer.errors[key].length > 0) {
        observer.refs[key].$el.scrollIntoView({block: "center", behavior: "smooth"});
        return;
      }
    }
  },

  showError(error: AxiosResponse<BaseResponse> | string) {
    if (!error) return;

    if ((error as AxiosResponse<BaseResponse>).status === 403) {
      return;
    }
    
    console.log("error: ", error);
    if (typeof error === "string") {
      this.error("<div class=\"tw-text-center\">" + i18n.t(`message.${error}`) + "</div>");
    } else if (error.data) {
      let popup = false;
      let err = "";
      const { data: { messages } } = error as AxiosResponse<BaseResponse>;
      if (messages && messages.length === 1) {
        err += "<div class=\"tw-text-center\">" + i18n.t(`message.${messages[0].code}`) + "</div>";
        if (!messages[0].field) {
          popup = true;
        }
      }
      if (messages && messages.length > 1) {
        err = "<ul role=\"list\" class=\"tw-list-disc tw-pl-5 tw-space-y-1\">";
        messages.forEach(item => {
          if (!item.field) {
            popup = true;
            err += "<li>" + i18n.t(`message.${item.code}`) + "</li>";
          }
        });
        err += "</ul>";
      }
      // const errorCode = data.messages && data.messages.length > 0 ? data.messages[0].code : "";
      if (popup) {
        this.error(err);
      }
    }
  },

  showApiError(messages: Dictionary<ApiMessage[]>, observer: any) {
    if (observer) {
      const errors = {};
      if (!isEmpty(messages)) {
        for (const [key, value] of Object.entries(messages)) {
          errors[key] = value.map((val) => i18n.t(`message.${val.code}`));
        }
      }
      observer.setErrors(errors);
    }
  },

  confirm(message, title = null, options: any = {}) {
    return this.open(Object.assign({
      message,
      title,
      buttons: [
        { value: 'no', label: options.noButtonLabel || this._getButtonLabel('no'), reject: true, secondary: true },
        { value: 'yes', label: options.yesButtonLabel || this._getButtonLabel('yes') }
      ]
    }, options));
  },

  prompt(message, title = null, options: any = {}) {
    return this.open(Object.assign({
      message,
      title,
      inputs: '<input type="text">',
      buttons: [
        { value: 'cancel', label: options.cancelButtonLabel || this._getButtonLabel('cancel'), reject: true, secondary: true },
        { value: 'ok', label: options.okButtonLabel || this._getButtonLabel('ok') }
      ]
    }, options));
  },

  _getButtonLabel(type) {
    if (`${type}ButtonLabel` in this) {
      if (typeof this[`${type}ButtonLabel`] === 'function') {
        return this[`${type}ButtonLabel`]();
      }
      return this[`${type}ButtonLabel`];
    }
    return '';
  }
};

export default UtilPlugin;
